import Iconify from "../ui/Iconify";
import { PopularSearchItem } from "./popular-search-parts";
import { getPopularSearchKey } from "./search-keyboard-navigation";
import { hasRealPopularSearches } from "./popular-search-data";

const DesktopPopularSearchPanel = ({
  popularItems,
  updatedAt,
  onSubmit,
  desktopNavigationState,
}) => {
  const hasRealPopularity = hasRealPopularSearches(popularItems);
  const activeKey = desktopNavigationState?.activeKey || "";
  const setActiveKey = desktopNavigationState?.setActiveKey;

  return (
    <section className="pt-5">
      <div className="mb-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Iconify
            icon="lucide:trending-up"
            className="!h-4 !w-4 text-black/45 dark:text-white/45"
          />
          <h2 className="text-[16px] font-semibold leading-5">
            {hasRealPopularity ? "인기 검색어" : "추천 검색어"}
          </h2>
        </div>
        {hasRealPopularity && (
          <span className="shrink-0 text-[12px] font-medium text-black/40 dark:text-white/40">
            12시간마다 업데이트
          </span>
        )}
      </div>

      <div className="overflow-hidden rounded-2xl border border-black/5 bg-black/[0.015] px-3 py-1 dark:border-white/10 dark:bg-white/[0.04]">
        {popularItems.length > 0 ? (
          popularItems.map((item, index) => {
            const itemKey = getPopularSearchKey(item);

            return (
              <PopularSearchItem
                key={itemKey}
                item={item}
                index={index}
                total={popularItems.length}
                isActive={activeKey === itemKey}
                onMouseEnter={() => setActiveKey?.(itemKey)}
                onSubmit={onSubmit}
                variant="desktop"
                showRanking={hasRealPopularity}
              />
            );
          })
        ) : (
          <div className="flex min-h-[64px] items-center text-[14px] font-medium text-black/40 dark:text-white/40">
            검색어를 입력해보세요
          </div>
        )}
      </div>
      {popularItems.length > 0 && hasRealPopularity && (
        <div className="pt-2 pr-1 text-right text-[11px] font-medium text-black/35 dark:text-white/35">
          {updatedAt} 기준
        </div>
      )}
    </section>
  );
};

export default DesktopPopularSearchPanel;
